import React from "react";
import { Box, InputAdornment, TextField, SearchIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldWithEndAdorn = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"TextField with end icon"}
        language={"js"}
        value={`
        <TextField
          label="Outlined"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon fontSize="small"/>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Filled"
          variant="filled"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon fontSize="small"/>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Standard"
          variant="standard"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon fontSize="small"/>
              </InputAdornment>
            ),
          }}
        />
        `}
      >
        <TextField
          label="Outlined"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                  <SearchIcon fontSize="small"/>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Filled"
          variant="filled"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                  <SearchIcon fontSize="small"/>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Standard"
          variant="standard"
          placeholder={"search"}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                  <SearchIcon fontSize="small"/>
              </InputAdornment>
            ),
          }}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default TextFieldWithEndAdorn;
